import one360 from './one360';
import type { RegisterVaillantSerialNumberResult } from '../../interfaces/vaillant';

export async function registerVaillantSerialNumber(
  serialNumber: string,
  email?: string,
): Promise<RegisterVaillantSerialNumberResult> {
  return one360.post<RegisterVaillantSerialNumberResult>(
    '/api/v1/vaillant/register-serial-number',
    { serialNumber, email },
  );
}
